import React from 'react';

var DEFAULT_LIST_CONTEXT = {
  disabled: false,
  itemTag: 'span'
};
var ListContextInner = React.createContext(DEFAULT_LIST_CONTEXT);

export { DEFAULT_LIST_CONTEXT, ListContextInner };
